import { useEffect, useRef } from "react"

const AdsterraNativeBanner = () => {
    const hasLoaded = useRef(false)
    const containerId = "container-70d5ae2820b3eedfde5ee930b10912dd"

    useEffect(() => {
        // Évite de charger plusieurs fois (StrictMode, navigation, etc.)
        if (hasLoaded.current) return

        // Création et chargement du script
        const script = document.createElement("script")
        script.async = true
        script.setAttribute("data-cfasync", "false")
        script.src =
            "https://accuracyinstalled.com/70d5ae2820b3eedfde5ee930b10912dd/invoke.js"

        document.head.appendChild(script)
        hasLoaded.current = true

        // Nettoyage au démontage du composant
        return () => {
            if (document.head.contains(script)) {
                document.head.removeChild(script)
            }
            hasLoaded.current = false
        }
    }, [])

    return (
        <div
            id={containerId}
            style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                maxWidth: "900px",
                margin: "0 auto",
                marginTop: "10px",
                minHeight: "280px", // Hauteur minimale pour éviter les sauts de layout
                textAlign: "center",
                overflow: "hidden",
                backgroundColor: "rgba(0, 0, 0, .6)", // Fond léger pour mieux voir en test
                borderRadius: "8px",
                padding: "10px 0",
            }}
        />
    )
}

export default AdsterraNativeBanner
